<template>
    <div>
        <div class="row">
            <div class="page-header">
                <div class="d-flex align-items-center">

                    <h2 class="page-header-title">
                        <router-link to="/extinguisher-reports">
                        Extinguisher Reports</router-link>
                        &raquo;
                        <router-link :to="{ name: 'extinguisher-report-view', params: {action: 'view', id: extinguisherReport.site_extinguisher_report_id} }">
                            {{ extinguisherReport.job_number }} | {{ extinguisherReport.prepared_for }}
                        </router-link>
                        &raquo;
                        <span v-if="isEdit">Edit</span><span v-else>Add</span> Extinguisher</h2>
                </div>
            </div>
        </div>

        <form @submit.prevent="submit">
            <div class="form-body">
                <div style="display:none;">
                    <div class="col-lg-6 col-md-12"><input type="hidden" name="_method" value="POST"/></div>
                </div>
                <div class="form-body">
                    <input
                            name="site_extinguisher_report_id"
                            type="hidden"
                            v-model="extinguisher.site_extinguisher_report_id"
                    >
                    <input
                            name="site_extinguisher_report_item_id"
                            type="hidden"
                            v-model="extinguisher.site_extinguisher_report_item_id"
                    >
                    <div class="row">
                        <div class="col-sm-12 widget-20">
                            <div class="widget has-shadow">
                                <div class="widget-header bordered d-flex align-items-center section-header">
                                    <h2>Extinguisher Details</h2>
                                </div>
                                <div class="widget-body">

                                    <div class="col-lg-6 col-md-12">
                                        <input
                                                name="extinguisher_report_id"
                                                id="extinguisher_report_id"
                                                type="hidden"
                                                v-model="extinguisher.extinguisher_report_id"
                                        />
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('extinguisher_identifier')]"
                                                for="extinguisher_identifier">
                                            Extinguisher ID
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="extinguisher_identifier"
                                                    id="extinguisher_identifier"
                                                    :class="['form-control', getFieldClasses('extinguisher_identifier')]"
                                                    v-model="extinguisher.extinguisher_identifier"
                                                    maxlength="255"
                                                    class="form-control"
                                                    ref="first"
                                                    type="text"
                                                    @blur="onFieldBlur('extinguisher_identifier')"
                                            />
                                            <div v-if="!$v.extinguisher['extinguisher_identifier'].required" class="invalid-feedback">This field is required</div>
                                            <div v-if="isErrorField('extinguisher_identifier') && $v.extinguisher['extinguisher_identifier'].required" class="invalid-feedback">This extinguisher ID is not unique within the report!</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('extinguisher_location')]"
                                                for="extinguisher_location">
                                            Extinguisher Location
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="extinguisher_location"
                                                    id="extinguisher_location"
                                                    :class="['form-control', getFieldClasses('extinguisher_location')]"
                                                    v-model="extinguisher.extinguisher_location"
                                                    type="text"
                                                    maxlength="255"
                                                    class="form-control"
                                                    @blur="onFieldBlur('extinguisher_location')"
                                            />
                                            <div v-if="isErrorField('extinguisher_location')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('extinguisher_type')]"
                                                for="extinguisher_type">
                                            Extinguisher Type
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="extinguisher_type"
                                                    id="extinguisher_type"
                                                    :class="['form-control', getFieldClasses('extinguisher_type')]"
                                                    v-model="extinguisher.extinguisher_type"
                                                    @blur="onFieldBlur('extinguisher_type')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="extinguisherTypeOption.extinguisher_type_name" v-for="extinguisherTypeOption in extinguisherTypes" v-bind:key="extinguisherTypeOption.extinguisher_type_id">{{ extinguisherTypeOption.extinguisher_type_name }}</option>
                                                <option value=" ">Other, please specify</option>
                                            </select>
                                            <div v-if="isErrorField('extinguisher_type')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div v-if="extinguisher.extinguisher_type !== '' && typeNamesArray.indexOf(extinguisher.extinguisher_type) === -1">
                                        <div class="form-group row d-flex align-items-center d-none">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end" for="extinguisher-type-override">
                                                Specify Extinguisher Type
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="extinguisher_type_override"
                                                        id="extinguisher-type-override"
                                                        :class="['form-control', { 'has-error': submitting }]"
                                                        v-model="extinguisher.extinguisher_type"
                                                        type="text"
                                                >
                                                <div v-if="isErrorField('extinguisher_type')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('extinguisher_capacity')]"
                                                for="extinguisher_capacity">
                                            Extinguisher Capacity
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="extinguisher_capacity"
                                                    id="extinguisher_capacity"
                                                    :class="['form-control', getFieldClasses('extinguisher_capacity')]"
                                                    v-model="extinguisher.extinguisher_capacity"
                                                    @blur="onFieldBlur('extinguisher_capacity')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="extinguisherCapacityOption.extinguisher_capacity_name" v-for="extinguisherCapacityOption in extinguisherCapacities" v-bind:key="extinguisherCapacityOption.extinguisher_capacity_id">{{ extinguisherCapacityOption.extinguisher_capacity_name }}</option>
                                                <option value=" ">Other, please specify</option>
                                            </select>
                                            <div v-if="isErrorField('extinguisher_capacity')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div v-if="extinguisher.extinguisher_capacity !== '' && capacityNamesArray.indexOf(extinguisher.extinguisher_capacity) === -1">
                                        <div class="form-group row d-flex align-items-center d-none">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end" for="extinguisher-capacity-override">
                                                Specify Extinguisher Capacity
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="extinguisher_capacity_override"
                                                        id="extinguisher-capacity-override"
                                                        :class="['form-control', { 'has-error': submitting }]"
                                                        v-model="extinguisher.extinguisher_capacity"
                                                        type="text"
                                                >
                                                <div v-if="isErrorField('extinguisher_capacity')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('extinguisher_finish')]"
                                                for="extinguisher_finish">
                                            Extinguisher Finish
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="extinguisher_finish"
                                                    id="extinguisher_finish"
                                                    :class="['form-control', getFieldClasses('extinguisher_finish')]"
                                                    v-model="extinguisher.extinguisher_finish"
                                                    @blur="onFieldBlur('extinguisher_finish')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="extinguisherFinishOption.extinguisher_finish_name" v-for="extinguisherFinishOption in extinguisherFinishes" v-bind:key="extinguisherFinishOption.extinguisher_finish_id">{{ extinguisherFinishOption.extinguisher_finish_name }}</option>
                                                <option value=" ">Other, please specify</option>
                                            </select>
                                            <div v-if="isErrorField('extinguisher_finish')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div v-if="extinguisher.extinguisher_finish !== '' && finishNamesArray.indexOf(extinguisher.extinguisher_finish) === -1">
                                        <div class="form-group row d-flex align-items-center d-none">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end" for="extinguisher-finish-override">
                                                Specify Extinguisher Finish
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="extinguisher_finish_override"
                                                        id="extinguisher-finish-override"
                                                        :class="['form-control', { 'has-error': submitting }]"
                                                        v-model="extinguisher.extinguisher_finish"
                                                        type="text"
                                                >
                                                <div v-if="isErrorField('extinguisher_finish')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('extinguisher_position')]"
                                                for="extinguisher_position">
                                            Extinguisher Position
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="extinguisher_position"
                                                    id="extinguisher_position"
                                                    :class="['form-control', getFieldClasses('extinguisher_position')]"
                                                    v-model="extinguisher.extinguisher_position"
                                                    @blur="onFieldBlur('extinguisher_position')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="extinguisherPositionOption.extinguisher_position_name" v-for="extinguisherPositionOption in extinguisherPositions" v-bind:key="extinguisherPositionOption.extinguisher_position_id">{{ extinguisherPositionOption.extinguisher_position_name }}</option>
                                                <option value=" ">Other, please specify</option>
                                            </select>
                                            <div v-if="isErrorField('extinguisher_position')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div v-if="extinguisher.extinguisher_position !== '' && positionNamesArray.indexOf(extinguisher.extinguisher_position) === -1">
                                        <div class="form-group row d-flex align-items-center d-none">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end" for="extinguisher-position-override">
                                                Specify Extinguisher Position
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="extinguisher_position_override"
                                                        id="extinguisher-position-override"
                                                        :class="['form-control', { 'has-error': submitting }]"
                                                        v-model="extinguisher.extinguisher_position"
                                                        type="text"
                                                >
                                                <div v-if="isErrorField('extinguisher_position')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end text-right">
                                            <label :class="[getContainerClasses('weight_checked')]">
                                                Weight of Extinguisher Checked?</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="weight_checked-yes"
                                                           name="weight_checked"
                                                           v-model="extinguisher.weight_checked"
                                                           class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="weight_checked-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="weight_checked-no"
                                                           name="weight_checked"
                                                           v-model="extinguisher.weight_checked"
                                                           class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="weight_checked-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="weight_checked-na"
                                                           name="weight_checked"
                                                           v-model="extinguisher.weight_checked"
                                                           class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="weight_checked-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end text-right">
                                            <label :class="[getContainerClasses('tamper_tag_replaced')]">
                                                Tamper Tag Replaced?</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="tamper_tag_replaced-yes"
                                                           name="tamper_tag_replaced"
                                                           v-model="extinguisher.tamper_tag_replaced"
                                                           class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="tamper_tag_replaced-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="tamper_tag_replaced-no"
                                                           name="tamper_tag_replaced"
                                                           v-model="extinguisher.tamper_tag_replaced"
                                                           class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="tamper_tag_replaced-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="tamper_tag_replaced-na"
                                                           name="tamper_tag_replaced"
                                                           v-model="extinguisher.tamper_tag_replaced"
                                                           class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="tamper_tag_replaced-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label :class="[getContainerClasses('is_signage_present')]">
                                                Signage Present?</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" v-bind:value="true" id="extinguisher-signage-pass"
                                                           name="is_signage_present"
                                                           v-model="extinguisher.is_signage_present"
                                                           class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="extinguisher-signage-pass">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" v-bind:value="false" id="extinguisher-signage-fail"
                                                           name="is_signage_present"
                                                           v-model="extinguisher.is_signage_present"
                                                           class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="extinguisher-signage-fail">No</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label :class="[getContainerClasses('extinguisher_condition')]">
                                                Extinguisher Condition</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" v-bind:value="'Pass'" id="extinguisher-condition-pass"
                                                           name="extinguisher_condition"
                                                           v-model="extinguisher.extinguisher_condition"
                                                           class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="extinguisher-condition-pass">Pass</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" v-bind:value="'Due Test'" id="extinguisher-condition-due-test"
                                                           name="extinguisher_condition"
                                                           v-model="extinguisher.extinguisher_condition"
                                                           class="question-option--radio-as-button__2 template-option--radio-as-button__duetest"
                                                    >
                                                    <label for="extinguisher-condition-due-test">Due Test</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" v-bind:value="'Condemned'" id="extinguisher-condition-fail"
                                                           name="extinguisher_condition"
                                                           v-model="extinguisher.extinguisher_condition"
                                                           class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="extinguisher-condition-fail">Condemned</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                for="extinguisher_extended_service_date">
                                            Extinguisher Extended Service Date
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <datepicker
                                                    v-model="extinguisher.extinguisher_extended_service_date"
                                                    format="dd/MM/yy"
                                                    input-class="form-control"
                                                    name="extinguisher_extended_service_date"
                                            ></datepicker>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end" for="additional_comments">
                                            Additional Comments
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <textarea
                                                    class="form-control"
                                                    name="additional_comments"
                                                    maxlength="2000"
                                                    id="additional_comments"
                                                    rows="5"
                                                    v-model="extinguisher.additional_comments"
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            Extinguisher Photo
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <div v-if="extinguisher.extinguisher_offline_image != null">
                                                <img v-bind:src="extinguisher.extinguisher_offline_image.data" class="img-fluid">
                                            </div>
                                            <div v-else-if="extinguisher.extinguisher_image != null">
                                                <img v-bind:src="this.cmsUrl + extinguisher.extinguisher_image" class="img-fluid">
                                            </div>
                                            <div class="pt-2">
                                                <div v-if="addingExtinguisherPhoto">
                                                    <div v-if="isImageUploading" style="background: #eaeaea; padding: 10px; margin: 10px 0;">
                                                        <h3><span class="fa fa-spin fa-circle-notch"></span>
                                                            Adding image... Please wait...</h3>
                                                    </div>
                                                    <label class="fileContainer">
                                                        <span class="fa fa-camera"></span> Click to add an image
                                                        <input type="file" accept="image/*" capture="camera" @change="onFileChange">
                                                    </label>
                                                </div>
                                                <a v-else class="btn btn-square btn-lg btn-outline-primary"
                                                    href="javascript:void(0)"
                                                    v-on:click="addExtinguisherPhoto"
                                                ><span v-if="extinguisher.extinguisher_offline_image != null || extinguisher.extinguisher_image != null">Replace</span><span v-else>Add</span> photo</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="alert alert-danger" v-if="isError">
                                        <p class="mb-0">
                                            <strong>The following fields have errors or are missing:</strong>
                                        </p>
                                        <ul class="mb-0 pl-3" v-if="errors.length > 0">
                                            <li v-for="error in errors" v-bind:key="error.field">
                                                <span v-if="error.field">{{ 'form.'+error.field }}<span v-if="error.message">: error.message</span></span>
                                                <span v-else-if="error.message">error.message</span>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">

                            <div class="form-group">
                                <button type="submit" class="btn btn-primary btn-square btn-lg w-100" :disabled="submitting">
                                    <span v-if="submitting">Submitting... <i class="fa fa-circle-notch fa-spin"></i></span>
                                    <span v-else>Save</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </form>



    </div>
</template>

<style>
    .form-control {
        background: #fff !important;
    }
    .vdp-datepicker__calendar .selected {
        background: var(--primary-color) !important;
        color: #fff;
    }
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
        border: 1px solid var(--primary-color) !important;
    }
</style>


<script>

    import { required } from 'vuelidate/lib/validators';
    import ImageRotate from '@/components/mixins/ImageRotate.js';
    import moment from 'moment';
    import Datepicker from 'vuejs-datepicker';

    var Compress = require('compress.js');
    var EXIF = require('exif-js');

    export default {
        mixins: [ImageRotate],
        data() {
            return {
                addingExtinguisherPhoto: false,
                isImageUploading: false,
                isEdit: false,
                isSubmitted: false,
                isError: false,
                errorHeader: 'error.invalidFields',
                errors: [],
                submitting: false,
                extinguisher: {
                    extinguisher_report_item_id: null,
                    site_extinguisher_report_item_id: Math.floor(new Date().getTime() / 1000),
                    extinguisher_report_id: null,
                    site_extinguisher_report_id: null,
                    extinguisher_identifier: null,
                    extinguisher_location: null,
                    extinguisher_type: null,
                    extinguisher_capacity: null,
                    extinguisher_finish: null,
                    extinguisher_position: null,
                    weight_checked: null,
                    tamper_tag_replaced: null,
                    extinguisher_extended_service_date: null,
                    is_signage_present: null,
                    extinguisher_condition: null,
                    extinguisher_image: null,
                    additional_comments: null,
                    user_id: null,
                    extinguisher_offline_image: null
                },
                extinguisherReport: {
                    extinguisher_report_id: null,
                    job_number: 'Loading...',
                    prepared_for: 'Please wait...',
                    site_extinguisher_report_id: this.isEdit ? null : this.$route.params.id,
                },
                extinguisherTypes: [],
                extinguisherCapacities: [],
                extinguisherFinishes: [],
                extinguisherPositions: [],
                assetsIDs: [],
            }
        },
        validations: {
            extinguisher: {
                extinguisher_identifier: { 
                    required, 
                    isIdentifierUnique(value) {
                        if (value === '') {
                            return true;
                        }

                        return !this.assetsIDs.includes(value);
                    }
                },
                extinguisher_location: { required },
                extinguisher_type: { required },
                extinguisher_capacity: { required },
                extinguisher_finish: { required },
                extinguisher_position: { required },
                is_signage_present: { required },
                extinguisher_condition: { required }
            },
        },
        components: {
            Datepicker
        },
        methods: {
            addExtinguisherPhoto() {
                this.addingExtinguisherPhoto = true;
            },
            onFileChange(e) {
                this.isImageUploading = true;
                var files = e.target.files || e.dataTransfer.files
                if (!files.length) {
                    this.isImageUploading = false;
                    return;
                }
                var vm = this;
                EXIF.getData(files[0], function() {
                    var orientation = EXIF.getTag(this, "Orientation");
                    vm.createImage(files[0], orientation);
                });
            },
            createImage(file, orientation) {
                var compress = new Compress()
                var files = [file]
                var vm = this;
                compress.compress(files, {
                    size: 4, // the max size in MB, defaults to 2MB
                    quality: .6, // the quality of the image, max is 1,
                    maxWidth: 700, // the max width of the output image, defaults to 1920px
                    maxHeight: 700, // the max height of the output image, defaults to 1920px
                    resize: true, // defaults to true, set false if you do not want to resize the image width and height
                }).then(async (data) => {
                    var imgSrc = data[0].prefix + data[0].data;
                    var rotationDegrees = 0;
                    switch(orientation) {
                        case 3:
                            rotationDegrees = 180;
                            break;
                        case 6:
                            rotationDegrees = -90;
                            break;
                        case 8:
                            rotationDegrees = 90;
                            break;    
                    }

                    if(rotationDegrees != 0) {
                        await this.rotateImage(imgSrc, rotationDegrees).then(newDataUri => {
                            console.log('Image rotated');
                            imgSrc = newDataUri;
                        }).catch(e => {
                            console.log(e);
                        });
                    }

                    console.log('Image added to array');
                    this.extinguisher.extinguisher_offline_image = {
                        'data': imgSrc, 
                        'alt': data[0].alt, 
                        'orientation': orientation
                    };
                    this.isImageUploading = false;
                    this.addingExtinguisherPhoto = false;
                });
            },
            getExtinguisherTypes() {
                var vmt = this;
                this.getDb(function onConnectedDb(db) {
                    vmt.extinguisherTypes = [];
                    try {
                        var objectStore = db.transaction('extinguisher_types').objectStore('extinguisher_types');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.extinguisherTypes) {
                                        vmt.extinguisherTypes.push({
                                            extinguisher_type_id: cursor.value.extinguisher_type_id,
                                            extinguisher_type_name: cursor.value.extinguisher_type_name
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getExtinguisherCapacities() {
                var vmt = this;
                this.getDb(function onConnectedDb(db) {
                    vmt.extinguisherCapacities = [];
                    try {
                        var objectStore = db.transaction('extinguisher_capacities').objectStore('extinguisher_capacities');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.extinguisherCapacities) {
                                        vmt.extinguisherCapacities.push({
                                            extinguisher_capacity_id: cursor.value.extinguisher_capacity_id,
                                            extinguisher_capacity_name: cursor.value.extinguisher_capacity_name
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getExtinguisherFinishes() {
                var vmt = this;
                this.getDb(function onConnectedDb(db) {
                    vmt.extinguisherFinishes = [];
                    try {
                        var objectStore = db.transaction('extinguisher_finishes').objectStore('extinguisher_finishes');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.extinguisherFinishes) {
                                        vmt.extinguisherFinishes.push({
                                            extinguisher_finish_id: cursor.value.extinguisher_finish_id,
                                            extinguisher_finish_name: cursor.value.extinguisher_finish_name
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getExtinguisherPositions() {
                var vmt = this;
                this.getDb(function onConnectedDb(db) {
                    vmt.extinguisherPositions = [];
                    try {
                        var objectStore = db.transaction('extinguisher_positions').objectStore('extinguisher_positions');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.extinguisherPositions) {
                                        vmt.extinguisherPositions.push({
                                            extinguisher_position_id: cursor.value.extinguisher_position_id,
                                            extinguisher_position_name: cursor.value.extinguisher_position_name
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            generateExtinguisherId() {
                var vm = this;
                this.getDb(function onConnectedDb(db) {
                    try {
                        var objectStore = db.transaction('extinguisher_report_items').objectStore('extinguisher_report_items');
                        //console.log(objectStore);
                        if (objectStore) {
                            var reportExtinguishers = [];
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    //console.log(cursor.value.site_extinguisher_report_id);
                                    if(cursor.value.site_extinguisher_report_id == vm.extinguisherReport.site_extinguisher_report_id) {
                                        reportExtinguishers.push(cursor.value);
                                        if(cursor.value.extinguisher_identifier !== null && (cursor.value.is_deleted === false || cursor.value.is_deleted === undefined)) {
                                            vm.assetsIDs.push(cursor.value.extinguisher_identifier);
                                        }
                                    }
                                    cursor.continue();
                                } else {
                                    if(reportExtinguishers.length == 0) {
                                        vm.extinguisher.extinguisher_identifier = '1';
                                    } else {
                                        var maxId = 0;
                                        reportExtinguishers.forEach((tempExt, i, array) => {
                                            if(tempExt.extinguisher_identifier == null) {
                                                return;
                                            }

                                            try {
                                                //It can be any string really, so let's better parse it in try catch block
                                                var tempId = parseInt(tempExt.extinguisher_identifier); 
                                                if(tempId > maxId) {
                                                    maxId = tempId;
                                                }
                                            } catch(e) {
                                                console.error(e);
                                            }
                                        });
                                        vm.extinguisher.extinguisher_identifier = (maxId + 1).toString();
                                    }
                                }
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getExtinguisher() {
                var vm = this;
                this.getDb(function onConnectedDb(db) {
                    try {
                        var extinguisherId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('extinguisher_report_items').objectStore('extinguisher_report_items');
                        var storeRequest = objectStore.get(extinguisherId);
                        storeRequest.onsuccess = function(event) {
                            vm.extinguisher = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                vm.getExtinguisherReport(false);
                                vm.fetchAllAssetsIDs();
                            }
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            fetchAllAssetsIDs() {
                if(this.extinguisher.site_extinguisher_report_id === null) {
                    return;
                }

                var vm = this;
                this.getDb(function onConnectedDb(db) {
                    try {
                        var objectStore = db.transaction('extinguisher_report_items').objectStore('extinguisher_report_items');
                        //console.log(objectStore);
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    //console.log(cursor.value.site_extinguisher_report_id);
                                    if(cursor.value.site_extinguisher_report_id == vm.extinguisher.site_extinguisher_report_id
                                     && (cursor.value.is_deleted === false || cursor.value.is_deleted === undefined)) {
                                        if(cursor.value.extinguisher_identifier !== null && cursor.value.site_extinguisher_report_item_id !== vm.extinguisher.site_extinguisher_report_item_id) {
                                            vm.assetsIDs.push(cursor.value.extinguisher_identifier);
                                        }
                                    }
                                    cursor.continue();
                                }
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getExtinguisherReport(generateExtinguisherId) {
                var vm = this;
                this.getDb(function onConnectedDb(db) {
                    try {
                        var reportId = vm.isEdit ? vm.extinguisher.site_extinguisher_report_id : parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('extinguisher_reports').objectStore('extinguisher_reports');
                        var storeRequest = objectStore.get(reportId);
                        storeRequest.onsuccess = function(event) {
                            vm.extinguisherReport = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                //console.log(vm.extinguisherReport);
                                vm.extinguisher.site_extinguisher_report_id = vm.extinguisherReport.site_extinguisher_report_id;
                                vm.extinguisher.extinguisher_report_id = vm.extinguisherReport.extinguisher_report_id;
                                if(generateExtinguisherId) {
                                    vm.generateExtinguisherId();
                                }
                            }
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.sendFormData();
                } else {
                    this.validationError();
                }
            },
            enableSubmitLoader() {
                this.submitting = true;
            },
            disableSubmitLoader() {
                this.submitting = false;
            },
            sendFormData() {
                this.enableSubmitLoader();

                var vmt = this;
                this.getDb(function onConnectedDb(db) {

                    var putRequest = db.transaction('extinguisher_report_items', 'readwrite')
                        .objectStore('extinguisher_report_items').put({
                            extinguisher_report_item_id: vmt.extinguisher['extinguisher_report_item_id'],
                            site_extinguisher_report_item_id: vmt.extinguisher['site_extinguisher_report_item_id'],
                            extinguisher_report_id: vmt.extinguisher['extinguisher_report_id'],
                            site_extinguisher_report_id: vmt.extinguisher['site_extinguisher_report_id'],
                            extinguisher_identifier: vmt.extinguisher['extinguisher_identifier'],
                            extinguisher_location: vmt.extinguisher['extinguisher_location'],
                            extinguisher_type: vmt.extinguisher['extinguisher_type'],
                            extinguisher_capacity: vmt.extinguisher['extinguisher_capacity'],
                            extinguisher_finish: vmt.extinguisher['extinguisher_finish'],
                            extinguisher_position: vmt.extinguisher['extinguisher_position'],
                            weight_checked: vmt.extinguisher['weight_checked'],
                            tamper_tag_replaced: vmt.extinguisher['tamper_tag_replaced'],
                            extinguisher_extended_service_date: vmt.extinguisher['extinguisher_extended_service_date'],
                            is_signage_present: vmt.extinguisher['is_signage_present'],
                            extinguisher_condition: vmt.extinguisher['extinguisher_condition'],
                            extinguisher_image: vmt.extinguisher['extinguisher_image'],
                            additional_comments: vmt.extinguisher['additional_comments'],
                            user_id: vmt.$session.get('user_id'),
                            extinguisher_offline_image: vmt.extinguisher['extinguisher_offline_image']
                        });
                    putRequest.onsuccess = function(event) {
                        vmt.submitSuccess({
                            success: true,
                            site_extinguisher_report_item_id: putRequest.result,
                        })
                    }
                    putRequest.onerror = function(event) {
                        alert("Unable to add data ");
                    };
                })

            },
            submitSuccess(response) {
                if (response.success) {
                    this.isSubmitted = true;
                    this.isError = false;
                    this.$router.push({ name: 'extinguisher-report-view-extinguisher', params: {id: response.site_extinguisher_report_item_id} })
                } else {
                    this.errorHeader = 'error.invalidFields';
                    this.errors = response.data.errors;
                    this.isError = true;
                }
            },
            submitError(error) {
                this.errorHeader = 'error.general';
                this.errors = [{'field': null, 'message': 'error.generalMessage'}];
                this.isError = true;
            },
            validationError() {
                this.errorHeader = 'error.invalidFields';
                this.errors = this.getErrors();
                this.isError = true;
            },
            isErrorField(field) {
                try {
                    if (this.getValidationField(field).$error) {
                        return true;
                    }
                } catch (error) {}

                return this.errors.some(el => el.field === field);
            },
            getErrors() {
                let errors = [];
                for (var field of Object.keys(this.extinguisher)) {
                    try {
                        if (this.getValidationField(field).$error) {
                            errors.push({'field': field, 'message': null});
                        }
                    } catch (error) {}
                }
                return errors;
            },
            getFieldClasses(field) {
                return { 'is-invalid': this.isErrorField(field) }
            },
            getContainerClasses(field) {
                return { 'text-danger': this.isErrorField(field) }
            },
            getValidationField(field) {
                if (this.$v.extinguisher[field]) {
                    return this.$v.extinguisher[field];
                }
                throw Error('No validation for field ' + field);
            },
            onFieldBlur(field) {
                try {
                    this.getValidationField(field).$touch();
                    if (this.getValidationField(field).$error) {
                        if (!this.errors.some(el => el.field === field)) {
                            this.errors.push({'field': field, 'message': null});
                        }
                    } else {
                        this.errors = this.errors.filter(el => el.field !== field);
                    }
                } catch (error) {}
            },
            reload() {
                window.location = '';
            },
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FER') === -1) {
                this.$router.push('/');
                return;
            }

            this.getExtinguisherTypes();
            this.getExtinguisherCapacities();
            this.getExtinguisherFinishes();
            this.getExtinguisherPositions();

            if (this.$route.name === 'extinguisher-report-edit-extinguisher') {
                this.isEdit = true;
            }
            
            if (!this.isEdit) {
                this.getExtinguisherReport(true);
                var serviceDate = new Date();
                serviceDate.setFullYear(serviceDate.getFullYear() + 1);
                this.extinguisher.extinguisher_extended_service_date = moment(serviceDate).format('YYYY-MM-DD');
            } else {
                this.getExtinguisher();
            }
        },
        computed: {
            typeNamesArray() {
                var values = [];
                this.extinguisherTypes.forEach(option => {
                    values.push(option.extinguisher_type_name);
                });
                return values;
            },
            capacityNamesArray() {
                var values = [];
                this.extinguisherCapacities.forEach(option => {
                    values.push(option.extinguisher_capacity_name);
                });
                return values;
            },
            finishNamesArray() {
                var values = [];
                this.extinguisherFinishes.forEach(option => {
                    values.push(option.extinguisher_finish_name);
                });
                return values;
            },
            positionNamesArray() {
                var values = [];
                this.extinguisherPositions.forEach(option => {
                    values.push(option.extinguisher_position_name);
                });
                return values;
            },
        }
    }
</script>

<style scoped>
    form {
        margin-bottom: 2rem;
    }

    [class*='-message'] {
        font-weight: 500;
    }

    .has-error {
        border: 1px solid #d33c40;
    }

    .error-message {
        color: #d33c40;
    }

    .success-message {
        color: #32a95d;
    }
</style>